export default "__VITE_PUBLIC_ASSET__42110477__"